import { Flex } from 'antd'
import { GetPlastic } from 'features/card/get-plastic-card'
import { GetVirtualCard } from 'features/card/get-virtual-card/ui/GetVirtualCard'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { selectCurrentAccountObject } from 'shared/config/store/selectors'
import { getCurrentEmi } from 'shared/config/store/selectors/app'
import { getAccountCards } from 'shared/config/store/reducers/cardsSlice'
import { useResultModal } from 'shared/libs/hooks/useResultModal/useResultModal'
import { ActionButton } from 'shared/ui'
import CardIcon from 'shared/ui/CardIcon/CardIcon'
import { AVAILABLE_BALANCE_HOLD_EUR, getLedgerBalance } from 'shared/libs/utils/balance';

const MIN_VIRTUAL_EUR = 3;
const MIN_PLASTIC_EUR = 7;

export const GetCards = () => {
  const { formatMessage: t } = useIntl();
  const [showPlastic, setShowPlastic] = useState(false);
  const [showVirtual, setShowVirtual] = useState(false);
  const currentAccount = useSelector(selectCurrentAccountObject);
  const currentEmi = useSelector(getCurrentEmi);
  const accountCards = useSelector(getAccountCards(currentEmi, currentAccount?.id));
  const { showResult } = useResultModal();

  const closePlastic = () => {
    setShowPlastic(false);
  }

  const closeVirtual = () => {
    setShowVirtual(false);
  }

  const checkAndOpen = (minIssueEur: number, messageId: string, openDrawer: () => void) => {
    const hasAnyCard = accountCards.length > 0;
    const requiredBalance = hasAnyCard ? minIssueEur + AVAILABLE_BALANCE_HOLD_EUR : minIssueEur;
    const ledgerBalance = getLedgerBalance(currentAccount?.available);
    const topUpNeeded = Math.max(0, requiredBalance - ledgerBalance);

    if (!currentAccount || ledgerBalance < requiredBalance) {
      showResult({ type: 'warning', title: t({ id: messageId }, { amount: topUpNeeded }) });
      return
    }
    openDrawer();
  }

  const onClickVirtual = () => {
    checkAndOpen(MIN_VIRTUAL_EUR, "card.virtual.messages.topup", () => setShowVirtual(true));
  }

  const onClickPlastic = () => {
    checkAndOpen(MIN_PLASTIC_EUR, "card.getPlastic.messages.topup", () => setShowPlastic(true));
  }

  return (
    <>
      <Flex gap={10}>
        <ActionButton
          image={
            <CardIcon
              size="s"
              cardNumber="••••"
            />
          }
          text={t({id: 'river.plasticCard'})}
          onClick={onClickPlastic}
        />
        <ActionButton
          image={<CardIcon
            size="s"
            cardNumber="••••"
          />}
          text={t({id: 'river.virtualCard'})}
          onClick={onClickVirtual}
        />
        <GetPlastic open={showPlastic} onClose={closePlastic} />
        <GetVirtualCard open={showVirtual} onClose={closeVirtual} />
      </Flex>
    </>
  )
}